import { ActionTypes } from "redux/reducers/issues/types";
import {
    api_get,
    api_post,
    api_put,
    PROYECT
} from "services/api";
import {
    setSnackbar,
    startRequestComp,
    stopRequestComp
} from "../search/searchActions";

const {
    GET_ISSUES,
    SET_ISSUES_FILTERS,
    SET_EDIT_ISSUE,
    SET_ASSIGN_ISSUE,
    UPDATE_ISSUE,
    NEW_ISSUE
} = ActionTypes

const serviceTypes = [
    { id: "LEAK", text: "FUGA" },
    { id: "COMPLAINT", text: "QUEJA" },
    { id: "SERVICE", text: "SERVICIO" },
    { id: "OTHER", text: "OTRO" }
]

const statuses = [
    { id: "ACTIVE", text: "ACTIVO" },
    { id: "ASSIGNED", text: "ASIGNADO" },
    { id: "RESOLVED", text: "RESUELTO" },
    { id: "CANCELED", text: "CANCELADO" }
]


const baseUrl = `${process.env.REACT_APP_URL}${PROYECT}/issues`

export const getIssues = (start = "", end = "", stations = []) => {
    const paramsString = `?start=${start}&end=${end}&${stations.map(s => `stations=${encodeURIComponent(s.id)}`).join('&')}`
    return async (dispatch) => {
        dispatch(startRequestComp('loadingIssues'))
        await api_get(baseUrl + paramsString).then(resp => {
            if (resp.length === 0) {
                dispatch(setSnackbar('No se encontraron quejas', 'info'))
            }

            dispatch({
                type: GET_ISSUES,
                payload: {
                    issues: resp.map(obj => ({
                        ...obj,
                        stationName: obj.customer?.account?.station?.name,
                        accountCode: obj.customer?.account?.code,
                        unitNumber: obj.unit?.number,
                        serviceTypeName: serviceTypes.find(x => x.id === obj.serviceType)?.text || 'DESCONOCIDO',
                        statusName: statuses.find(x => x.id === obj.status)?.text || 'DESCONOCIDO'
                    })),
                    stations: stations,
                    startDate: start,
                    endDate: end
                }
            })
        }).catch(error => {
            dispatch(setSnackbar(error, 'Error'))
        }).finally(() => {
            dispatch(stopRequestComp('loadingIssues'))
        })
    }
}

export const createIssue = (data, callback) => {
    return async (dispatch) => {
        dispatch(startRequestComp('createIssue'))
        await api_post(baseUrl, data).then(resp => {
            dispatch(setSnackbar('Ticket creado correctamente', 'success'))
        }).catch(error => {
            dispatch(setSnackbar(error, 'Error'))
        }).finally(() => {
            dispatch(stopRequestComp('createIssue'))
            if (typeof callback == 'function') callback()
        })
    }
}

export const editIssue = (data, callback) => {
    return async (dispatch) => {
        dispatch(startRequestComp('editIssue'))
        await api_put(baseUrl + `/${data.id}`, data).then(resp => {
            dispatch({
                type: UPDATE_ISSUE,
                payload: resp
            })
            dispatch(setSnackbar('Ticket editado correctamente', 'success'))
        }).catch(error => {
            dispatch(setSnackbar(error, 'Error'))
        }).finally(() => {
            dispatch(stopRequestComp('editIssue'))
            if (typeof callback == 'function') callback()
        })
    }
}

export const cancelIssue = (id, callback) => {
    return async (dispatch) => {
        dispatch(startRequestComp('cancelIssue'))
        await api_put(baseUrl + `/${id}`, { status: 'CANCELED' }).then(resp => {
            dispatch({
                type: UPDATE_ISSUE,
                payload: resp
            })

            dispatch(setSnackbar('Ticket cancelado correctamente', 'success'))
        }).catch(error => {
            dispatch(setSnackbar(error, 'Error'))
        }).finally(() => {
            dispatch(stopRequestComp('cancelIssue'))
            if (typeof callback == 'function') callback()
        })
    }
}

export const assignIssue = (data, callback) => {
    return async (dispatch) => {
        dispatch(startRequestComp('assignIssue'))
        await api_put(baseUrl + `/${data.id}`, data).then(resp => {
            dispatch({
                type: UPDATE_ISSUE,
                payload: resp
            })

            dispatch(setSnackbar('Ticket asignado correctamente', 'success'))
        }).catch(error => {
            dispatch(setSnackbar(error, 'Error'))
        }).finally(() => {
            dispatch(stopRequestComp('assignIssue'))
            if (typeof callback == 'function') callback()
        })
    }
}

export const setEditIssue = (data) => ({
    type: SET_EDIT_ISSUE,
    payload: data
})

export const setAssignIssue = (data) => ({
    type: SET_ASSIGN_ISSUE,
    payload: data
})

export const setIssuesFilters = (key = "", data) => ({
    type: SET_ISSUES_FILTERS,
    payload: { data, key }
})